import React from 'react'
import { makeStyles } from 'tss-react/mui'

import { Theme, Typography } from '@mui/material'

import { CorporateListViewProvider } from './CorporateListViewStore'
import { CorporateListViewActions } from './CorporateListViewActions.component'
import { CorporateListViewContent } from './CorporateListViewContent.component'

export function CorporateListView() {
  const { classes } = useStyles()
  return (
    <CorporateListViewProvider>
      <div className={classes.headerContainer}>
        <Typography className={classes.headline}>Corporate</Typography>
        <CorporateListViewActions className={classes.headerActions} />
      </div>
      <CorporateListViewContent className={classes.content} />
    </CorporateListViewProvider>
  )
}

const useStyles = makeStyles()(({ spacing, typography, breakpoints }: Theme) => ({
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing(2),
  },
  headerActions: {
    display: 'flex',
  },
  content: {
    position: 'relative',
    minHeight: spacing(50),
  },
  headline: {
    display: 'inline-block',
    fontSize: typography.h5.fontSize,
    [breakpoints.down('sm')]: {
      fontSize: typography.subtitle1.fontSize,
    },
  },
}))
